import cardSlides from './cardSlides';

const lgSlides = cardSlides;

export default lgSlides;
